import React from "react";
import NoDataFound from "./NoData";
import VoucherCard from "./VoucherCard";
import CustomSlider from "../../components/Slider/CustomSlider";
import { FormatFlooringVouchers } from "../../common/Constants";

function PendingContent(props) {
  const { pending_vouchers, handleCreateNewClick, HandleEdit, HandleDelete, pagePermission } =
    props;
  const handleNoDataClick = () => {
    handleCreateNewClick();
  };
  const HandlePendingEdit = (id, label) => {
    HandleEdit(id, label, "pending")
  }

  const updatedPendingVoucher = FormatFlooringVouchers(pending_vouchers?.map((it) => {
    return {
      ...it,
      active: it?.active == 1 ? false : true,
      temp_date: it?.created_date
    };
  }));


  return (
    <div className="pending-vouchers-section">
      {pending_vouchers?.length === 0 ? (
        <NoDataFound
          onNewClick={handleNoDataClick}
          btnName="Create New Voucher"
          heading="Oh oh! No Voucher Found"
          noDataInfo="Seems like you don’t have any voucher available. Click below to create a new one."
        />
      ) : (
        updatedPendingVoucher && updatedPendingVoucher?.length > 0 && updatedPendingVoucher?.map((it) => (
          <div>
            <div className="hr-line-menu">
              <div className="hr-line-block">
                <h2>
                  <span>Created on:</span>
                  {it?.date}
                </h2>
              </div>
            </div>
            <div className="voucher-preview-section pendingVouchers">
              <CustomSlider>
                {it?.vouchers?.length > 0 &&
                  it?.vouchers.map((voucher, index) => (
                    <VoucherCard
                      key={index}
                      voucher={voucher}
                      showBentoMenu={true}
                      type="pending"
                      HandleEdit={HandlePendingEdit}
                      HandleDelete={HandleDelete}
                      pagePermission={pagePermission}
                    />
                  ))}
              </CustomSlider>
              {/* <CustomSlider>

            </CustomSlider> */}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default PendingContent;
